import React, { useEffect, useState } from 'react';
import { BaseTableProps } from 'react-base-table';
import { Skeleton } from 'antd';

import Table from '@components/common/Table';

import { TableHeader, TableTitle, Wrapper } from './styled';

const HEADER_HEIGHT = 28;
const ROW_HEIGHT = 34;
const MAX_HEIGHT = 460;
const TABLE_HEADER_HEIGHT = 40;
const TABLE_PADDING_HEIGHT = 16;

export const UsageBaseTable: React.FC<
  {
    loading?: boolean;
    accountType?: string; // Video, DPI, API
  } & Omit<BaseTableProps, 'width'>
> = ({ accountType, loading = false, ...tableProps }) => {
  const [tableHeight, setTableHeight] = useState<number>(MAX_HEIGHT);

  const headerText = `${accountType} Usage`;

  useEffect(() => {
    const contentHeight =
      (tableProps?.data?.length ?? 0) * ROW_HEIGHT +
      HEADER_HEIGHT +
      TABLE_HEADER_HEIGHT +
      TABLE_PADDING_HEIGHT +
      ROW_HEIGHT; // Adding the height of ROW_HEIGHT is to prevent the appearance of scroll bars on some Macs.
    const height = Math.min(contentHeight, MAX_HEIGHT);
    setTableHeight(height);
  }, [tableProps?.data?.length]);

  if (loading) {
    return <Skeleton active paragraph={{ rows: 5, width: '100%' }} />;
  }

  return (
    <Wrapper style={{ height: tableHeight }}>
      <TableHeader>
        <TableTitle>{headerText}</TableTitle>
      </TableHeader>
      <Table
        headerHeight={HEADER_HEIGHT}
        rowHeight={ROW_HEIGHT}
        ignoreFunctionInColumnCompare={false}
        {...tableProps}
      />
    </Wrapper>
  );
};
